$(document).foundation();
$(document).ready(function () {
	window['initColorThemes']();
	window['initOffCanvas']();
	window['initOverView']();
	window['initPopup']();
	window['initBooking']();
	window['customAccordionPositioning']();
	window['customNewsletterForm']();
	window['customPDFLinks']();
	// window['initLogoCarousel']();
	window['initThingsToDo']();
	// window['initHideVideoMobile']();
	window['initTeam']();
	window['initTwitter']();
	window['initModalScroll']();


	window['initLazyLoading']();

	//group specific
	initGroupFooterSocial();
	initGroupTimeGreeting();
	initScrollingText();
	initGroupHomeSliders();
	initGroupLanding();
	addGroupCuratorHover();
});

initGroupBooking();


var initThingsToDo = function () {
	if ( $('.things-to-do').length > 0 ) {
		setThingsToDoContentHeight();
		$(window).on('resize', setThingsToDoContentHeight);

		$('.things-to-do__content').css('height', 0);

		$('.things-to-do__item').on('mouseenter mouseleave touchend', function (e) {
			if ( $('html').hasClass('whatinput-types-touch') ) {
				// Is touchscreen
				$('.things-to-do__item.on').removeClass('on');
				$('.things-to-do__content').css('height', 0);

				$(this).toggleClass('on');

				if ( $(this).hasClass('on') ) {
					$(this).find('.things-to-do__content').css('height', $(this).find('.things-to-do__content').data('content-height') + 'px' );
				} else {
					$(this).find('.things-to-do__content').css('height', 0);
				}
			} else {
				// Is mouse
				$(this).toggleClass('on');

				if ( $(this).hasClass('on') ) {
					$(this).find('.things-to-do__content').css('height', $(this).find('.things-to-do__content').data('content-height') + 'px' );
				} else {
					$(this).find('.things-to-do__content').css('height', 0);
				}
			}
		});
	}
}

var setThingsToDoContentHeight = function () {
	$('.things-to-do__content').each(function () {
		$(this).css('overflow', 'auto');
		$(this).data('content-height', $(this).find('.things-to-do__content-inner').outerHeight());
		$(this).css('overflow', 'hidden');
	});
}



// var initLogoCarousel = function () {
// 	$('.logo-carousel__inner').slick({
// 		infinite: false,
// 		  slidesToShow: 2,
// 		  slidesToScroll: 2
// 	});
// }


var initHideVideoMobile = function () {
	if ($('.slider__video iframe').length > 0) {

		if ($( window ).width() < 640) {
			$('.slider__video').hide();
			$('.mobile-slider').show();
			//$('.wrapper').css('margin-top', 115);
		} else {
			$('.slider__inner').show();
			$('.slider__video').show();
			$('.wrapper').css('margin-top', 0);
			$('.mobile-slider').hide();
		}
	}
}

$(window).on('resize', function() {
	// initHideVideoMobile();
	resizeTeamWindow();
})



// Customised version to deal with smaller logo required for scroll
var initHeader = function () {

	function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last,
		  deferTimer;
	  return function () {
		var context = scope || this;

		var now = +new Date,
			args = arguments;
		if (last && now < last + threshhold) {
		  // hold on to it
		  clearTimeout(deferTimer);
		  deferTimer = setTimeout(function () {
			last = now;
			fn.apply(context, args);
		  }, threshhold);
		} else {
		  last = now;
		  fn.apply(context, args);
		}
	  };
	}

	// Detect if the header is over and image slider, if yes then give it a transparent background
	setHeaderTransparency();
	$(window).on('scroll', setHeaderTransparency);

	if ( !$('body').hasClass('theme-bird') ) {
		$('.header').addClass('visible'); // only show the header after the transparency has been set
		$('.group-header').addClass('visible');
	}

	function setHeaderTransparency() {

		if ( $('body.group').length > 0 ) {
			if (window.pageYOffset < 150) {
				$('.group-header').removeClass('group-header--scrolled');
				if ($('.group-slider').length > 0) {
					$('.group-header').addClass('group-header--transparent');
				}
			} else {
				$('.group-header').addClass('group-header--scrolled');
				$('.group-header').removeClass('group-header--transparent');
			}
		} else {

			if (window.pageYOffset < 150) {
				$('.header').removeClass('header--scrolled');
				if ($('.slider, .sliders').length > 0) {
					$('.header').addClass('header--transparent');
				}
			} else {
				$('.header').addClass('header--scrolled');
				$('.header').removeClass('header--transparent');
			}
		}
	}

	if( $('body').hasClass('group') ) {
		$('.group-header').on('mouseenter', function() {
			$('.group-header__logo').removeClass('white');
		})
		$('.group-header').on('mouseleave', function() {
			$('.group-header__logo').addClass('white');
		})
	}





	// Set up the main Bird logo for the hover aniamtion effect
	if ( $('body').hasClass('theme-bird') ) {
		$('.header__logo img').each(function () {
			var $img = $(this);
			var imgID = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL = $img.attr('src');

			if ((UrlExists(imgURL)) && (imgURL.indexOf('.svg') > -1)) {
				$.get(imgURL, function (data) {
					// Get the SVG tag, ignore the rest
					var $svg = $(data).find('svg');

					// Add replaced image's ID to the new SVG
					if (typeof imgID !== 'undefined') {
						$svg = $svg.attr('id', imgID);
					}
					// Add replaced image's classes to the new SVG
					if (typeof imgClass !== 'undefined') {
						$svg = $svg.attr('class', imgClass + ' replaced-svg');
					}

					// Remove any invalid XML tags as per http://validator.w3.org
					$svg = $svg.removeAttr('xmlns:a');

					// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
					if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
						$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
					}

					// Replace image with new SVG
					$img.replaceWith($svg);
				}, 'xml');

				setTimeout(function () {
					$('.header').addClass('visible'); // only show the header after the transparency has been set
				}, 150);
			}
		});


	}
}

var initSlider = function () {
	var sliderSettings = settings.slider;
	sliderSettings.speed = 6000;

	if ( $('body.group').length > 0 ) {
		// If there's no slider, make sure that the content starts below the header
		if ( $('.group-slider').length === 0) {
			pushContentBelowHeader();
			$(window).on('resize', pushContentBelowHeader);
			$('.group-header').addClass('group-header--no-slider');
			$('main').addClass('group-pad');
		}

		$('.group-slider__slider').slick({
			dots: false,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 8000,
			lazyLoad: 'progressive'
		});

	} else {
		$('.slider__inner').reformSlider(
			sliderSettings
		);

		$('.mobile-slider__inner').reformSlider(
			sliderSettings
		);


		//video logic is handled by priority js

		// if ($('.slider__video').length > 0) {
		// 	coverViewport($('.slider__video iframe'), true);
		// 	$(window).on('resize', function () {
		// 		coverViewport($('.slider__video iframe'), true);
		// 	});
		// }

		// If there's no slider, make sure that the content starts below the header
		if ( ($('.slider').length === 0) && ($('.sliders').length === 0)) {
			pushContentBelowHeader();
			$(window).on('resize', pushContentBelowHeader);
			//$('.header').addClass('header--transparent');
		}
	}
}






var initAnimateInView = function () {
	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();
}

function animateElementsInView() {
	$('[data-animate-in-view]').each(function () {
		if ( $(this).hasClass('in-view') ) {
			return;
		}

		if ( isElementInViewport($(this)) ) {
			var elementToAnimate = this;

			$(elementToAnimate).addClass('in-view'); // log that this element has been seen


			setTimeout(function () {
				$(elementToAnimate).addClass( $(elementToAnimate).data('animate-in-view') ); // apply the animation class
			}, 300);


			if ( typeof $(elementToAnimate).data('map-load-on-view') != 'undefined' ) { // only load this map once it's in view
				buildMap(elementToAnimate);
			}
		}
	});
}

function isElementInViewport (el) {
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	var rect = el.getBoundingClientRect();

	var t = rect.y;
	var b = window.innerHeight - rect.y - rect.height;
	var h = window.innerHeight;

	if (
		( (t >= 0) && (t <= h) ) ||
		( (b >= 0) && (b <= h) )
	) {
		return true;
	} else {
		return false;
	}
}





var initOtherRooms = function () {
	// Custom colours since the carousel item ordering breaks CSSs odd/even styles
	$('.other-rooms__room:nth-child(even)').addClass('other-rooms__item--even');


	$('.other-rooms__carousel').on('init', function (event, slick) {
		Foundation.reInit('equalizer');
	});

	$('.other-rooms__carousel').slick({
		slidesToShow: 2,
		arrows: true,
		responsive: [
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
}







var initAccommodation = function () {
	$('.accommodation__views button').on('click', function () {
		if ( $(this).hasClass('current') ) {
			return;
		}

		// Remove the transition classes to avoid the weird morphing effect
		$('.accommodation .transition--2000').removeClass('transition--2000');

		// Switch the button current states
		$('.accommodation__views button.current').removeClass('current')
		$(this).addClass('current');

		$('.accommodation__items').toggleClass('accommodation__items--list-view').toggleClass('accommodation__items--grid-view');
	});

	if ( window.innerWidth < 640 ) {
		$('.accommodation__items').removeClass('accommodation__items--list-view').addClass('accommodation__items--grid-view');
	}
}






var initColorThemes = function () {
	if ( $('body').hasClass('theme-orange') ) {
		$('.intro .button').not('.button--black-text').addClass('button--orange');
	} else if ( $('body').hasClass('theme-red') ) {
		$('.intro .button').not('.button--black-text').addClass('button--red');
	} else if ( $('body').hasClass('theme-brown') ) {
		$('.intro .button').not('.button--black-text').addClass('button--brown');
	} else if ( $('body').hasClass('theme-green') ) {
		$('.intro .button').not('.button--green-text').addClass('button--green');
	}



	$('.landing__item').each(function () {
		if ( $(this).find('h2 a').text().toLowerCase().indexOf('olio') > -1 ) {
			$(this).addClass('landing__item--orange');
		} else if ( $(this).find('h2 a').text().toLowerCase().indexOf('valentine') > -1 ) {
			$(this).addClass('landing__item--red');
		}
	});
}


if( $('body').hasClass('group') ) {
	var customMapStyle = [{"featureType":"all","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"lightness":40},{"color":"#d8d5d5"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"lightness":17},{"weight":1.2},{"visibility":"off"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#d8d5d5"},{"visibility":"on"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#d8d5d5"}]},{"featureType":"administrative.province","elementType":"labels.text.fill","stylers":[{"color":"#d8d5d5"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d8d5d5"}]},{"featureType":"administrative.neighborhood","elementType":"geometry.fill","stylers":[{"color":"#231f20"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#d8d5d5"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.fill","stylers":[{"color":"#231f20"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#d8d5d5"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#286d42"},{"lightness":20}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#286d42"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#286d42"},{"lightness":"0"},{"visibility":"on"}]},{"featureType":"poi.business","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#e0b74c"},{"lightness":"0"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#a1a1a1"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#575757"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#a1a1a1"}]},{"featureType":"road.arterial","elementType":"labels.text.stroke","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#a1a1a1"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"##000000"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"hue":"#00b4ff"},{"lightness":"-74"},{"saturation":"-51"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"##000000"}]}]
} else if( $('body').hasClass('theme-bishopstrow') ) {
var customMapStyle=[{featureType:"all",elementType:"geometry.fill",stylers:[{color:"#af5131"}]},{featureType:"all",elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#ffffff"},{lightness:40}]},{featureType:"all",elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#000000"},{lightness:16}]},{featureType:"all",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#341e10"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#341e10"},{lightness:17},{weight:1.2}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"landscape",elementType:"geometry.fill",stylers:[{color:"#af5131"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#000000"},{lightness:21}]},{featureType:"poi",elementType:"geometry.fill",stylers:[{color:"#af5131"}]},{featureType:"road",elementType:"geometry.fill",stylers:[{color:"#341e10"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#341e10"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:29},{weight:.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#000000"},{lightness:18}]},{featureType:"road.arterial",elementType:"geometry.fill",stylers:[{color:"#341e10"}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#000000"},{lightness:16}]},{featureType:"road.local",elementType:"geometry.fill",stylers:[{color:"#341e10"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#000000"},{lightness:19}]},{featureType:"transit",elementType:"geometry.fill",stylers:[{color:"#af5131"}]},{featureType:"transit.line",elementType:"geometry.fill",stylers:[{color:"#341e10"}]},{featureType:"transit.station",elementType:"geometry.fill",stylers:[{color:"#341e10"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#000000"},{lightness:17}]},{featureType:"water",elementType:"geometry.fill",stylers:[{color:"#341e10"}]}];
} else {
	var customMapStyle = [{featureType:"landscape",elementType:"all",stylers:[{color:"#c1a76c"},{lightness:"50"}]},{featureType:"poi",elementType:"all",stylers:[{color:"#aec1b1"},{lightness:"63"},{saturation:"0"}]},{featureType:"poi",elementType:"labels",stylers:[{color:"#535a52"},{weight:"0.01"},{lightness:"6"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#594e32"},{lightness:"-56"}]},{featureType:"poi",elementType:"labels.icon",stylers:[{color:"#555756"},{visibility:"on"},{lightness:"-33"},{saturation:"0"}]},{featureType:"poi.attraction",elementType:"geometry",stylers:[{visibility:"on"}]},{featureType:"poi.attraction",elementType:"labels.icon",stylers:[{hue:"#ff0000"},{visibility:"on"}]},{featureType:"road.highway",elementType:"all",stylers:[{hue:"#FFC200"},{saturation:-61.8},{lightness:45.599999999999994},{gamma:1}]},{featureType:"road.highway",elementType:"labels",stylers:[{color:"#535a52"},{weight:"0.01"}]},{featureType:"road.arterial",elementType:"all",stylers:[{hue:"#FF0300"},{saturation:-100},{lightness:51.19999999999999},{gamma:1}]},{featureType:"road.arterial",elementType:"labels.text",stylers:[{color:"#535a52"},{weight:"0.01"}]},{featureType:"road.local",elementType:"all",stylers:[{hue:"#FF0300"},{saturation:-100},{lightness:52},{gamma:1}]},{featureType:"water",elementType:"all",stylers:[{lightness:"-13"},{color:"#799cba"}]}];
}

var initMaps = function () {
	$('[data-map]').each(function () {
		var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;

		if (typeof $(this).data('map-center-coords') != 'undefined') {
			centerLat = parseFloat( $(this).data('map-center-coords').split(',')[0] );
			centerLng = parseFloat( $(this).data('map-center-coords').split(',')[1] );
		} else {
			centerLat = 0;
			centerLng = 0;
		}

		zoom = $(this).data('map-zoom') || 8;

		if ((typeof settings.mapStyle !== 'undefined') || (settings.mapStyle === false))  {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.LEFT_BOTTOM
				},
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,

				styles: customMapStyle
			});
		} else {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.LEFT_BOTTOM
				},
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false
			});
		}


		if (typeof $(this).data('map-marker-coords') != 'undefined') {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if ( $('body').hasClass('theme-bird') ) {
				marker.setIcon('/assets/img/bird/map-marker-bird.png');
			} else {
				if (typeof $(this).data('map-marker-url') != 'undefined') {
					marker.setIcon($(this).data('map-marker-url'));
				}
			}
		}

		$(this).siblings('[data-map-marker]').each(function () {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		});

		if (typeof $(this).data('map-directions') != 'undefined') {
			var directionsService  = new google.maps.DirectionsService();
			var directionsRenderer = new google.maps.DirectionsRenderer();
			directionsRenderer.setMap(map);
			directionsRenderer.setPanel($('#map-directions-data').get(0));

			var directionsTo = $(this).data('map-directions-destination');

			$('#frmPostcode').on('submit', function() {
				var directionsFrom = jQuery.trim(jQuery('#tbPostcode').val());
				var directionsRequest = {
					origin: directionsFrom,
					destination: directionsTo,
					travelMode: google.maps.TravelMode.DRIVING,
					unitSystem: google.maps.UnitSystem.IMPERIAL
				};

				directionsService.route(directionsRequest, function(result, status){
					if (status == google.maps.DirectionsStatus.OK) {
						marker.setMap(null);
						directionsRenderer.setDirections(result);
					} else {
						alert('Location "' + directionsFrom + '" not found.');
					}
				});

				return false;
			});
		}
	});
}


var initOverView = function () {

	$('.off-canvas__nav-primary > ul > li').each(function () {
		// Automatically add the "Overview" links to the landing page
		if ( $(this).find('ul').length > 0 ) {
			var overviewLink = $(this).find('a').first().attr('href');
			$(this).find('ul').prepend('<li><a href="' + overviewLink + '">Overview</a></li>');
		}
	});

	$('.group-off-canvas__nav-primary > ul > li').each(function () {
		// Automatically add the "Overview" links to the landing page
		if ( $(this).find('ul').length > 0 ) {
			var overviewLink = $(this).find('a').first().attr('href');
			$(this).find('ul').prepend('<li><a href="' + overviewLink + '">Overview</a></li>');
		}
	});

}



var initOffCanvas = function () {
	//$('#offCanvas').foundation('open');


	$('.off-canvas__nav-primary > ul > li > a').on('click', function () {
		if ( $(this).next('.off-canvas__nav-sub').length > 0 ) { // only trigger if there are sub pages to show
			if ( $(this).parent().hasClass('open') ) {
				// second click of main item allows clicking directly through
				return true;
			} else {
				// close any other open items
				$('.off-canvas__nav-primary > ul > li.open').removeClass('open').find('.off-canvas__nav-sub').slideUp();

				// and open the new one
				$(this).parent().addClass('open');
				$(this).next().slideDown();
			}
			return false; // prevent navigating
		}
	});

	$('.group-header__open-off-canvas button').on('click', function() {
		$('.group-header').css('display', 'none');
	})

	$('.group-off-canvas__close button').on('click', function() {
		$('.group-header').css('display', 'block');
	})

	$('.group-off-canvas__nav-primary > ul > li > a').on('click', function () {
		if ( $(this).next('.group-off-canvas__nav-sub').length > 0 ) { // only trigger if there are sub pages to show
			if ( $(this).parent().hasClass('open') ) {
				// second click of main item allows clicking directly through
				return true;
			} else {
				// close any other open items
				$('.group-off-canvas__nav-primary > ul > li.open').removeClass('open').find('.group-off-canvas__nav-sub').slideUp();

				// and open the new one
				$(this).parent().addClass('open');
				$(this).next().slideDown();
			}
			return false; // prevent navigating
		}
	});
}





var initPopup = function () {
	if ($('#popup').length > 0) {
		var popupDelay = $('#popup').data('popup-delay') || 0;
		var popupKeepHiddenFor = $('#popup').data('popup-keep-hidden-for-n-days') || 0;

		if (!Cookies.get('hasSeenPopup')) {
			setTimeout(function() {
				$('#popup').foundation('open');

				if (popupKeepHiddenFor > 0) {
					Cookies.set('hasSeenPopup', 'true', { expires: popupKeepHiddenFor });
				}
			}, popupDelay);
		}
	}

	function handleChristmasPopUp() {
		var popup = $(".christmas-popup");

		if (popup.length === 0) return;
		var image = $(".christmas-popup__img");
		var closeBtn = $('.christmas-popup__close')
		var content = $(".christmas-popup__content");
		var popupDelay = popup.data("popup-delay") || 0;
		var popupKeepHiddenFor = popup.data("popup-keep-hidden-for-n-days") || 0;

		if (Cookies.get("hasSeenPopup")) {
		popup.remove();
		return;
		}

		setTimeout(function () {
		popup.addClass("show");
		image.addClass("show");
		content.addClass("show");
		if (popupKeepHiddenFor > 0) {
			Cookies.set("hasSeenPopup", "true", { expires: popupKeepHiddenFor });
		}
		}, popupDelay);

		closeBtn.on('click', function () {
			popup.hide();
			popup.remove();
		})
	}
	handleChristmasPopUp();
}




// https://be.synxis.com/?&adult=1&arrive=2020-10-19&chain=32565&child=0&currency=GBP&depart=2020-10-20&hotel=5160&level=hotel&locale=en-GB&rooms=1
var initBooking = function () {

	// Editing specific booking links for the Bird
	if ( $('body').hasClass('theme-bird') ) {
		$('#rooms input[name="chain"]').val('32565');
		$('#rooms input[name="hotel"]').val('2442');
		$('#rooms input[name="locale"]').val('en-GB');
		$('#rooms input[name="configcode"]').remove();
		$('#rooms input[name="src"]').remove();


		// The Bird has no spa
		$('.booking-tabs--spa, .booking__tabs-content-spa').remove();

		$('.booking__tabs-content-table iframe')
			.data('src', 'https://booking.resdiary.com/widget/Standard/TheBirdBath/13593?includeJquery=true')
			.attr('height', '800');
	}

	// if ( $('body').hasClass('theme-bishopstrow') ) {
	// 	$('.booking-tabs--spa, .booking__tabs-content-spa').remove();
	// }

	function loadIframes () {
		var srcLoaded = false
		$('.header__open-booking').on('click', function () {
			// Only load 3rd party iframes when the booking panel is opened
			if (srcLoaded) return;
			srcLoaded = true;
			$('#booking iframe').each(function () {
				if (typeof $(this).data('src') != 'undefined') {
					$(this).attr('src', $(this).data('src'));
				}
			});
		});
	}

	loadIframes()

	$('#booking').on('open.zf.reveal', function () {
		// Only load 3rd party iframes when the booking panel is opened
		$('#booking iframe').each(function () {
			if (typeof $(this).data('src') != 'undefined') {
				$(this).attr('src', $(this).data('src'));
			}
		});
	});



	//$('#booking').foundation('open');

	$('.booking select').selectric();

	$('.booking__tabs-content-room-why-book').accordiom({
		showFirstItem: false
	});

	var bookingContainer = $('.booking__tabs-content-room form');
	var monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
	var dayNames   = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
	var nowTemp = new Date();
	var tomorrow = new Date();
		tomorrow.setDate(nowTemp.getDate() + 1);

	var $checkInField = bookingContainer.find('.check-in');
	var $checkOutField = bookingContainer.find('.check-out');

	$checkInField.on('hide.datepicker', function () {
		var checkInDate  = $checkInField.datepicker('getDate');
		var checkOutDate = $checkOutField.datepicker('getDate');
		var dayAfterCheckIn = new Date(checkInDate);
			dayAfterCheckIn.setDate(checkInDate.getDate() + 1);

		// Ensure checkout comes after checkin.
		// Otherwise it all gets a bit Restaurant at the End of the Universe-ey.
		if ( checkInDate >= checkOutDate ) {
			$checkOutField.datepicker('setDate', dayAfterCheckIn);
		}

		$checkOutField.datepicker('setStartDate', dayAfterCheckIn);

		$checkOutField[0].focus();
	});

	var checkin = $checkInField.datepicker({
		format: 'dd',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: nowTemp,
		pick: function (e) {
			// User-facing date fields
			$('.check-in-month-year').text( monthNames[e.date.getMonth()] + ' ' + e.date.getFullYear() );
			$('.check-in-day').text( dayNames[e.date.getDay()] );

			// Formatted date for the booking engine
			$('input[name="arrive"]').val( e.date.getFullYear() + '-' + pad( e.date.getMonth() + 1*1 , 2) + '-' + e.date.getDate() );
		}
	});

	var checkout = $checkOutField.datepicker({
		format: 'dd',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: tomorrow,
		pick: function (e) {
			// User-facing date fields
			$('.check-out-month-year').text( monthNames[e.date.getMonth()] + ' ' + e.date.getFullYear() );
			$('.check-out-day').text( dayNames[e.date.getDay()] );

			// Formatted date for the booking engine
			$('input[name="depart"]').val( e.date.getFullYear() + '-' + pad( e.date.getMonth() + 1*1 , 2) + '-' + e.date.getDate() );
		}
	});


	$('.booking__tabs-content-room .form').on('submit', function() {

		var ttCheckin = $('input[name="arrive"]').val();
		var ttCheckout = $('input[name="depart"]').val();
		var ttAdults = $('.adults-select select').val();
		var ttChildren = '&tt_children=0';
		var initialUrl = $('.input[name="url"]').val('https://be.synxis.com/');
		var urlEnd = $('input[name="url-end"]');

		if ( $('body').hasClass('theme-bird') ) {
			var apiKey = '&tt_api_key=5fed6141e9c94c638a43f5a12494dbe1';
		} else {
			var apiKey = '&tt_api_key=d2b8197ebdc8485e844f64b7174dbb45';
		}

		urlEnd.val( urlEnd.val() + apiKey + '&tt_checkin=' + ttCheckin + '&tt_checkout=' + ttCheckout + '&tt_adults=' + ttAdults + ttChildren );

	})



	// Table booking widgets
	$('a[href="#book-table"]').on('click', function () {

		if ( $('body').hasClass('theme-bird') ) {
			openDiningPopup('https://booking.resdiary.com/widget/Standard/TheBirdBath/13593?includeJquery=true');
		} else if( $('body').hasClass('theme-bishopstrow') ) {
			openDiningPopup('https://booking.resdiary.com/widget/Standard/BishopstrowHotelSpa/29983?includeJquery=true');
		} else {
			openDiningPopup('https://booking.resdiary.com/widget/Standard/HomewoodRestaurant/17170?includeJquery=true');
		}
		return false;
	});

	$('a[href="#book-dining-dome"]').on('click', function () {
		if ( $('body').hasClass('theme-bird') ) {
			openDiningPopup('https://booking.resdiary.com/widget/Standard/TheBirdBath/21132?includeJquery=true');
		} else if( $('body').hasClass('theme-bishopstrow') ) {
			openDiningPopup('https://booking.resdiary.com/widget/Standard/BishopstrowHotelSpa/29982?includeJquery=true');
		} else {
			openDiningPopup('https://booking.resdiary.com/widget/Standard/HomewoodRestaurant/21699?includeJquery=true');
		}
		return false;
	});

	$('a[href="#book-festive-table"]').on('click', function () {
		// if ( $('body').hasClass('theme-bird') ) {
			// openDiningPopup('https://booking.resdiary.com/widget/Standard/TheBirdBath/13593?includeJquery=true');
		// } else {
			openDiningPopup('https://booking.resdiary.com/widget/Standard/HomewoodRestaurant/26118?includeJquery=true');
		// }
		// return false;
	});

	function openDiningPopup(iframeLink) {


		var iframeHeight = '800';
		if ( $('body').hasClass('theme-bird') ) {
			iframeHeight = '800';
		}
		if ( $('body').hasClass('theme-bishopstrow') ) {
			iframeHeight = '800';
		}

		var modal = '<div class="modal"><div id="dining-modal" class="modal__inner"  role="dialog" aria-hidden="true"><button class="modal__close" aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><iframe src="' + iframeLink + 'width="300" height=' + iframeHeight +' frameborder="0"></iframe></div></div>'
		var $modal = $(modal);

		$('body').append($modal);

		setTimeout(function () {
			$('.modal').addClass('active')
		},1000)

		$('.modal__close').on('click', function () {
			$('.modal').removeClass('active')
			setTimeout(function () {
				$('.modal').remove()
			},1000)
		});
	}

	/*$('a[href*="synxis"]').each(function() {
		var $this = $(this);
		var $href = $this.attr('href');
		$this.attr("href", "https://r.triptease.io/redirect?url=" + $href);
	})*/
}

function initGroupBooking() {
	$('.group-booking__field select').selectric();

	$('#group-booking').on('open.zf.reveal', function () {
		// Only load 3rd party iframes when the booking panel is opened
		$('#group-booking iframe').each(function () {
			if (typeof $(this).data('src') != 'undefined') {
				$(this).attr('src', $(this).data('src'));
			}
		});
	});

	$('.group-booking__form-top .type-select').selectric().on('change', function() {
		var bookingType = $(this).val();
		switch (bookingType) {
			case 'room':
			$('.group-booking__form-location .selectric-wrapper').removeClass('selectric-active');
			$('.group-booking__form-main > div').removeClass('open');
			$('.group-booking__room-booking').addClass('open');
			$('.group-booking__form-location select').each(function() {
				if($(this).hasClass('room-select')) {
					$(this).parents('.selectric-room-select').addClass('selectric-active');
				}
			});
			break;
			case 'table':
			$('.group-booking__form-location .selectric-wrapper').removeClass('selectric-active');
			$('.group-booking__form-main > div').removeClass('open');
			$('.group-booking__table-booking').addClass('open');
			$('.group-booking__form-location select').each(function() {
				if($(this).hasClass('table-select')) {
					$(this).parents('.selectric-table-select').addClass('selectric-active');
				}
			});
			break;
			case 'dome':
			$('.group-booking__form-location .selectric-wrapper').removeClass('selectric-active');
			$('.group-booking__form-main > div').removeClass('open');
			$('.group-booking__dome-booking').addClass('open');
			$('.group-booking__form-location select').each(function() {
				if($(this).hasClass('dome-select')) {
					$(this).parents('.selectric-dome-select').addClass('selectric-active');
				}
			});
			break;
			case 'spa':
			$('.group-booking__form-location .selectric-wrapper').removeClass('selectric-active');
			$('.group-booking__form-main > div').removeClass('open');
			$('.group-booking__spa-booking').addClass('open');
			$('.group-booking__form-location select').each(function() {
				if($(this).hasClass('spa-select')) {
					$(this).parents('.selectric-spa-select').addClass('selectric-active');
				}
			});
			break;
		}
	})

	$('.group-booking__form-location .room-select').selectric().on('change', function() {
		var locationSelect = $(this).val();
		switch(locationSelect) {
			case 'room-homewood':
			$('.group-booking__room-booking .form input[type="hidden"]').remove()

			// COMMENTING TRIPTEASE VERSIONS - 24348
			// $('.group-booking__room-booking .form').attr('action', 'https://r.triptease.io/redirect');
			$('.group-booking__room-booking .form').attr('action', 'https://be.synxis.com/');

			// $('.group-booking__room-booking .form').prepend('<input type="hidden" name="url" value="https://be.synxis.com/"><input type="hidden" name="arrive"><input type="hidden" name="depart"><input type="hidden" name="chain" value="22402"><input type="hidden" name="hotel" value="33024"><input type="hidden" name="currency" value="GBP"><input type="hidden" name="level" value="hotel"><input type="hidden" name="locale" value="en-US"><input type="hidden" name="configcode" value="SLH_HOTEL"><input type="hidden" name="src" value="24C"><input type="hidden" name="url-end" value="">');
			$('.group-booking__room-booking .form').prepend('<input type="hidden" name="arrive"><input type="hidden" name="depart"><input type="hidden" name="chain" value="22402"><input type="hidden" name="hotel" value="33024"><input type="hidden" name="currency" value="GBP"><input type="hidden" name="level" value="hotel"><input type="hidden" name="locale" value="en-US"><input type="hidden" name="configcode" value="SLH_HOTEL"><input type="hidden" name="src" value="24C"><input type="hidden" name="url-end" value="">');

			break;

			case 'room-bird':
			$('.group-booking__room-booking .form input[type="hidden"]').remove()

			// $('.group-booking__room-booking .form').attr('action', 'https://r.triptease.io/redirect');
			$('.group-booking__room-booking .form').attr('action', 'https://be.synxis.com/');

			// $('.group-booking__room-booking .form').prepend('<input type="hidden" name="url" value="https://be.synxis.com/"><input type="hidden" name="arrive"><input type="hidden" name="depart"><input type="hidden" name="chain" value="32565"><input type="hidden" name="hotel" value="2442"><input type="hidden" name="currency" value="GBP"><input type="hidden" name="level" value="hotel"><input type="hidden" name="locale" value="en-GB"><input type="hidden" name="url-end" value="">');
			$('.group-booking__room-booking .form').prepend('<input type="hidden" name="arrive"><input type="hidden" name="depart"><input type="hidden" name="chain" value="32565"><input type="hidden" name="hotel" value="2442"><input type="hidden" name="currency" value="GBP"><input type="hidden" name="level" value="hotel"><input type="hidden" name="locale" value="en-GB"><input type="hidden" name="url-end" value="">');

			break;

			case 'room-bishopstrow':
			$('.group-booking__room-booking .form input[type="hidden"]').remove();

			$('.group-booking__room-booking .form').attr('action', 'https://be.synxis.com');

			$('.group-booking__room-booking .form').prepend('<input type="hidden" name="arrive"><input type="hidden" name="depart"><input type="hidden" name="chain" value="22402"><input type="hidden" name="hotel" value="36375"><input type="hidden" name="currency" value="GBP"><input type="hidden" name="level" value="hotel"><input type="hidden" name="locale" value="en-US">');
			break;

			case 'room-dukesbath':
			$('.group-booking__room-booking .form input[type="hidden"]').remove();

			$('.group-booking__room-booking .form').attr('action', 'https://be.synxis.com');

			$('.group-booking__room-booking .form').prepend('<input type="hidden" name="arrive"><input type="hidden" name="depart"><input type="hidden" name="chain" value="32565"><input type="hidden" name="hotel" value="46531"><input type="hidden" name="currency" value="GBP"><input type="hidden" name="level" value="hotel"><input type="hidden" name="locale" value="en-US">');
			break;
		}
	})

	$('.group-booking__form-location .table-select').selectric().on('change', function() {
		var locationSelect = $(this).val();
		switch(locationSelect) {
			case 'table-homewood':
			$('.group-booking__table-booking > div.active').removeClass('active');
			$('.group-booking__table-booking--homewood').addClass('active');
			break;

			case 'table-bird':
			$('.group-booking__table-booking > div.active').removeClass('active');
			$('.group-booking__table-booking--bird').addClass('active');
			break;

			case 'table-bishopstrow':
			$('.group-booking__table-booking > div.active').removeClass('active');
			$('.group-booking__table-booking--bishopstrow').addClass('active');
			break;
		}
	})

	$('.group-booking__form-location .dome-select').selectric().on('change', function() {
		var locationSelect = $(this).val();
		switch(locationSelect) {
			case 'dome-bird':
			$('.group-booking__dome-booking > div.active').removeClass('active');
			$('.group-booking__dome-booking--bird').addClass('active');
			break;

			case 'dome-bishopstrow':
			$('.group-booking__dome-booking > div.active').removeClass('active');
			$('.group-booking__dome-booking--bishopstrow').addClass('active');
			break;
		}
	})

	$('.group-booking__form-location .spa-select').selectric().on('change', function() {
		var locationSelect = $(this).val();
		switch(locationSelect) {
			case 'spa-homewood':
			$('.group-booking__spa-booking > div.active').removeClass('active');
			$('.group-booking__spa-booking--homewood').addClass('active');
			break;
		}
	})

	$('.group-booking__why-book').accordiom({
		showFirstItem: false
	});

	var bookingContainer = $('.group-booking__room-booking .form');
	var monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
	var dayNames   = [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ];
	var nowTemp = new Date();
	var tomorrow = new Date();
		tomorrow.setDate(nowTemp.getDate() + 1);

	var $checkInField = bookingContainer.find('.check-in');
	var $checkOutField = bookingContainer.find('.check-out');

	$checkInField.on('hide.datepicker', function () {
		var checkInDate  = $checkInField.datepicker('getDate');
		var checkOutDate = $checkOutField.datepicker('getDate');
		var dayAfterCheckIn = new Date(checkInDate);
			dayAfterCheckIn.setDate(checkInDate.getDate() + 1);

		// Ensure checkout comes after checkin.
		// Otherwise it all gets a bit Restaurant at the End of the Universe-ey.
		if ( checkInDate >= checkOutDate ) {
			$checkOutField.datepicker('setDate', dayAfterCheckIn);
		}

		$checkOutField.datepicker('setStartDate', dayAfterCheckIn);

		$checkOutField[0].focus();
	});

	var checkin = $checkInField.datepicker({
		format: 'dd',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: nowTemp,
		pick: function (e) {
			// User-facing date fields
			$('.check-in-month-year').text( monthNames[e.date.getMonth()] + ' ' + e.date.getFullYear() );
			$('.check-in-day').text( dayNames[e.date.getDay()] );

			// Formatted date for the booking engine
			$('input[name="arrive"]').val( e.date.getFullYear() + '-' + pad( e.date.getMonth() + 1*1 , 2) + '-' + e.date.getDate() );
		}
	});

	var checkout = $checkOutField.datepicker({
		format: 'dd',
		autoPick: true,
		autoHide: true,
		date: null,
		startDate: tomorrow,
		pick: function (e) {
			// User-facing date fields
			$('.check-out-month-year').text( monthNames[e.date.getMonth()] + ' ' + e.date.getFullYear() );
			$('.check-out-day').text( dayNames[e.date.getDay()] );

			// Formatted date for the booking engine
			$('input[name="depart"]').val( e.date.getFullYear() + '-' + pad( e.date.getMonth() + 1*1 , 2) + '-' + e.date.getDate() );
		}
	});

	$('.group-booking__form-main .room-booking form').on('submit', function() {

		var ttCheckin = $('input[name="arrive"]').val();
		var ttCheckout = $('input[name="depart"]').val();
		var ttAdults = $('.adults-select select').val();
		var ttChildren = '&tt_children=0';
		var initialUrl = $('.input[name="url"]').val('https://be.synxis.com/');
		var urlEnd = $('input[name="url-end"]');

		if ( $('body').hasClass('theme-bird') ) {
			var apiKey = '&tt_api_key=5fed6141e9c94c638a43f5a12494dbe1';
		} else {
			var apiKey = '&tt_api_key=d2b8197ebdc8485e844f64b7174dbb45';
		}

		urlEnd.val( urlEnd.val() + apiKey + '&tt_checkin=' + ttCheckin + '&tt_checkout=' + ttCheckout + '&tt_adults=' + ttAdults + ttChildren );
	})
}

function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}








var initGallery = function () {
	$('.gallery__item a').on('click', function () {
		var $clickedThumbnail = $(this);


		// Dynamically load the gallery slider into a reveal popup
		var modal = '<div id="gallery__modal" class="gallery__modal full reveal loading" data-reveal><button class="gallery__modal-close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">close</span></button><div class="gallery__modal-image"><img src="{{src}}"><button class="gallery__modal-prev">Previous</button><button class="gallery__modal-next">Next</button></div><div class="gallery__modal-content grid-x grid-margin-x"><div class="gallery__modal-caption cell small-12 medium-6">{{caption}}</div><div class="gallery__modal-cta cell small-12 medium-6">{{cta}}</div></div></div>';

		modal = modal.replace('{{src}}', $(this).attr('href'));
		modal = modal.replace('{{caption}}', $(this).data('title') || '');

		var cta = $(this).data('description') || '';
		if ( ( typeof $(this).data('book-link') !== 'undefined' ) && ( $(this).data('book-link') !== '' ) ) {
			cta += '<a href="' + $(this).data('book-link') + '" class="button button--green" target="_blank">' + ($(this).data('book-title') || 'Book Now') + '</a>';
		}
		modal = modal.replace('{{cta}}', cta);

		var $modal = modal;

		$('body').append($modal);

		$('#gallery__modal').foundation().on('closed.zf.reveal', function () {
			$('#gallery__modal').remove();
		});

		$('#gallery__modal').foundation('open');

		$('.gallery__modal-next').on('click', function () {
			$('#gallery__modal').foundation('close');
			$('#gallery__modal').remove();
			if ( $clickedThumbnail.parent().next(':visible').length > 0 ) { // is the next thumb visible?
				$clickedThumbnail.parent().next(':visible').find('a').trigger('click');
			} else if ( $clickedThumbnail.parent().nextUntil(':visible').length > 0 ) { // no, so find the next visible one
				$clickedThumbnail.parent().nextAll(':visible').first().find('a').trigger('click');
				$('#gallery__modal').foundation('close');
				$('#gallery__modal').remove();
			}
		});

		$('.gallery__modal-prev').on('click', function () {
			$('#gallery__modal').foundation('close');
			$('#gallery__modal').remove();
			if ( $clickedThumbnail.parent().prev(':visible').length > 0 ) { // is the previous thumb visible?
				$clickedThumbnail.parent().prev(':visible').find('a').trigger('click');
			} else if ( $clickedThumbnail.parent().prevUntil(':visible').length > 0 ) { // no, so find the next visible one that comes before this
				$clickedThumbnail.parent().prevAll(':visible').last().find('a').trigger('click');
				$('#gallery__modal').foundation('close');
				$('#gallery__modal').remove();
			}
		});

		return false;
	});

	refreshMasonry();
	$('.gallery').on('filter-changed', function () {
		setTimeout(refreshMasonry, 600);
	});

	Foundation.onImagesLoaded($('.gallery__item img'), refreshMasonry);

	function refreshMasonry() {
		$('.gallery__grid').masonry({
			columnWidth: '.gallery__item-sizer',
			itemSelector: '.gallery__item',
			percentPosition: true,
			horizontalOrder: true
		});
	};

	// Remove the transition class after loading to avoid jumpy thumbnails
	setTimeout(function () {
		$('.gallery__item').removeClass('transition--2000');
	}, 2000);



	// Remove empty filter buttons (if not handled by the plugin)
	$('.filter__buttons button').each(function () {
		if ( $(this).text() == '' ) {
			$(this).remove();
		}
	});


	$('.filter__buttons button').on('click', function () {
		// Apply the animation state as soon as a filter is chosen. Otherwise they don't all appear correctly
		$('.gallery__item').each(function () {
			if (! $(this).hasClass('in-view')  ) {
				$(this).addClass('in-view').addClass( $(this).data('animate-in-view') );
			}
		});
	});
}

// ticket 13869

setTimeout(refreshMasonry, 600);
$('.things-to-do').on('filter-changed', function () {
	setTimeout(refreshMasonry, 600);
});

Foundation.onImagesLoaded($('.things-to-do__item-wrapper img'), refreshMasonry);

function refreshMasonry() {
	$('.things-to-do__grid').masonry({
		columnWidth: '.things-to-do__item-sizer',
		itemSelector: '.things-to-do__item-wrapper',
		percentPosition: true,
		horizontalOrder: false
	});
};

// Remove the transition class after loading to avoid jumpy thumbnails
setTimeout(function () {
	$('.things-to-do__item-wrapper').removeClass('transition--2000');
}, 2000);

// ticket 13869 end



// The design of the accordion button being positioned to the left, means that depending on the amount of content in the button, each accordionContent needs to be pulled up by a different amount...
var customAccordionPositioning = function () {
	if ( $('.accordion').length > 0 ) {
		pullUpAccordionContent();
		$(window).on('resize', pullUpAccordionContent);
	}
}

function pullUpAccordionContent() {
	if ( $(window).innerWidth() > 640 ) {
		$('.accordion .accordionContent').each(function () {
			$(this).css('margin-top', '-' + ($(this).prev().find('h3').innerHeight() + 38*1) + 'px');
		});
	} else {
		$('.accordion .accordionContent').css('margin-top', '0');
	}
}




function customNewsletterForm() {
	// 2 inputs with the same ID on the same page doesn't work... have to manually trigger the footer checkbox when clicking on the label
	$('.footer .footer__newsletter-form label').on('click', function () {
		$(this).siblings('input[type="checkbox"]').each( function () {
			$(this).prop("checked", !$(this).prop("checked"));
		});
	});

	if ( $('body').hasClass('theme-bird') ) {
		$('.footer__newsletter-form').append('<div class="footer__newsletter-privacy cell small-order-5"><label><a href="/privacy-policy">View our privacy policy</a></label></div>');
	} else {
		$('.footer__newsletter-form').append('<div class="footer__newsletter-privacy cell small-order-5"><label><a href="/privacy">View our privacy policy</a></label></div>');
	}
}




var customPDFLinks = function () {
	// Automatically set PDFs to open in new windows
	$('a[href$=".pdf"]').attr('target', '_blank');
}



var initTeam = function () {
	$('.team__grid-item button').on('click', function () {
		var $clickedThumbnail = $(this);
		// Dynamically load the content into a reveal popup
		var modal = "<div id='team__modal' class='team__modal full reveal loading' data-reveal><div class='team__modal-inner' style='background-image: {{backgroundImage}}; background-color: {{backgroundColor}}'><div class='team__modal-inner-wrap grid-x' style='background-color: {{backgroundColorInner}}'><div class='show-for-medium cell'><button class='team__modal-close' data-close aria-label='Close modal' type='button'><span aria-hidden='true'>Close</span></button></div><div class='team__modal-image cell medium-5'><img src='{{src}}'><h3>{{fullName}}</h3><h4>{{jobTitle}}</h4></div><div class='team__modal-content cell medium-7 vertical-center'><div class='team__modal-caption cell small-12 medium-6'><p>{{caption}}</p></div></div><div class='show-for-small-only cell'><button class='team__modal-close' data-close aria-label='Close modal' type='button'><span aria-hidden='true'>Close</span></button></div></div><button class='team__modal-prev'>Previous</button><button class='team__modal-next'>Next</button></div></div>";
		// Quotation marks have to be this way around or the background wont load

		var thisContainer = $(this).closest('.team__grid-item');
		var getContainerBackgroundColor = thisContainer.find('.team__grid-item-wrap').css('background-color');
		var getContainerBackgroundImage = thisContainer.find('.team__grid-item-wrap').css('background-image');

		modal = modal.replace('{{src}}', $(this).data('url') || '');
		modal = modal.replace('{{caption}}', $(this).data('caption') || '');
		modal = modal.replace('{{fullName}}', $(this).data('full-name') || '');
		modal = modal.replace('{{fullNameMobile}}', $(this).data('full-name') || '');
		modal = modal.replace('{{jobTitle}}', $(this).data('job-title') || '');
		modal = modal.replace('{{jobTitleMobile}}', $(this).data('job-title') || '');
		modal = modal.replace('{{backgroundImage}}', getContainerBackgroundImage);
		modal = modal.replace('{{backgroundColor}}', getContainerBackgroundColor);
		modal = modal.replace('{{backgroundColorInner}}', getContainerBackgroundColor);

		var $modal = modal;
		$('body').append($modal);

		if ( $('body').hasClass('theme-bird') ) {
			var secondaryColor = thisContainer.find('h4').css('color');
			$('.team__modal h3').css('color', getContainerBackgroundColor)
			$('.team__modal h4').css('color', secondaryColor);
		}

		$('#team__modal').foundation().on('closed.zf.reveal', function () {
			$('#team__modal').remove();
		});

		$('#team__modal').foundation('open');

		$('.team__modal-next').on('click', function () {
			$('#team__modal').foundation('close');
			$('#team__modal').remove();
			if ( $clickedThumbnail.parents(".team__grid-item").next(':visible').length > 0 ) { // is the next thumb visible?
				$clickedThumbnail.parents(".team__grid-item").next(':visible').find('button').trigger('click');
			} else if ( $clickedThumbnail.parents(".team__grid-item").nextUntil(':visible').length > 0 ) { // no, so find the next visible one
				$clickedThumbnail.parents(".team__grid-item").nextAll(':visible').first().find('button').trigger('click');
				$('#team__modal').foundation('close');
				$('#team__modal').remove();
			}
		});
		
		$('.team__modal-prev').on('click', function () {
			$('#team__modal').foundation('close');
			$('#team__modal').remove();
			if ( $clickedThumbnail.parents(".team__grid-item").prev(':visible').length > 0 ) { // is the previous thumb visible?
				$clickedThumbnail.parents(".team__grid-item").prev(':visible').find('button').trigger('click');
			} else if ( $clickedThumbnail.parents(".team__grid-item").prevUntil(':visible').length > 0 ) { // no, so find the next visible one that comes before this
				$clickedThumbnail.parents(".team__grid-item").prevAll(':visible').last().find('button').trigger('click');
				$('#team__modal').foundation('close');
				$('#team__modal').remove();
			}
		}); 

		return false;
	});

	var card = $('.team__grid-item');

	if( $(window).outerWidth() > 1023 ) {
		card.on( 'mouseenter', function() {
			$(this).find('.team__grid-item-wrap').addClass('is-flipped');
		});

		card.on( 'mouseleave', function() {
			$(this).find('.team__grid-item-wrap').removeClass('is-flipped');
		});
	} else {
		card.on( 'click', function() {
			$(this).find('.team__grid-item-wrap').toggleClass('is-flipped');
		})
	}

	resizeTeamWindow();

	

}

function resizeTeamWindow () {
	if( $('.team') ) {
		var gridItemImg = $('.team__grid-item-inner-img');
		var imgWidth = gridItemImg.outerWidth();
		gridItemImg.css('height' ,imgWidth);
	}
}


function initLazyLoading () {
	var lazyImages = Array.from($(".lazy-img"));

	var options = {
		root: null,
		rootMargin: "150px 0px",
		threshold: 0,
		};

	var lazyImageObserver = new IntersectionObserver(callbackObserver, options);

	function presetImgSizeStyles(img) {
		if (
			img.nodeName === "SOURCE" ||
			img.nodeName === "DIV" ||
			img.classList.contains("bg-img") ||
			typeof img.dataset.presets !== "undefined"
			) {
			return;
			}

			img.style.width = "100%";
			img.style.height = "auto";
			img.style.display = "block";
			img.decoding = "async";
		}

	function handleImgTag(img) {
		img.src = img.dataset.src;
		delete img.dataset.src;
		lazyImageObserver.unobserve(img);
	}

	function callbackObserver(entries) {
		entries.forEach(function(entry) {
			var img = entry.target;

			if (!entry.isIntersecting) return;

			handleImgTag(img)
			lazyImageObserver.unobserve(img);
		});
	}


	// lazyImages.forEach(function (img) {
	// 	presetImgSizeStyles(img)
	//   })

	lazyImages.forEach(function (img) {
		lazyImageObserver.observe(img);
	});
}

function initGroupFooterSocial() {

	$('.group-footer__social .open-social').on('click', function(e) {
		e.preventDefault();
		$('.group-footer__panel').addClass('open');
	})

	$('.group-footer__panel-close').on('click', function(e) {
		e.preventDefault();
		$('.group-footer__panel').removeClass('open');
	})

	$('.group-off-canvas__panel').accordiom({
		showFirstItem: false
	})

	$('.open-off-canvas-social').on('click', function(e) {
		e.preventDefault()
		$('.group-off-canvas__panel .accordionButton').trigger('click');
	})

	$('.group-off-canvas__panel-close').on('click', function() {
		$('.group-off-canvas__panel .accordionButton').trigger('click');
	})
}

function initGroupTimeGreeting() {
	var date = new Date();
	var time = date.getHours()
	var dataGreeting = $('.group-intro__content h1 span');

	if( time < 12 ) {
		dataGreeting.data('greeting', 'morning');
		dataGreeting.html(''+ dataGreeting.data('greeting'));
	} else if ( (time >= 12) && (time < 18) ) {
		dataGreeting.data('greeting', 'afternoon');
		dataGreeting.html(''+ dataGreeting.data('greeting'));
	} else {
		dataGreeting.data('greeting', 'evening');
		dataGreeting.html(''+ dataGreeting.data('greeting'));
	}
}

function initScrollingText() {
	var startAni = function () {
		var elem = $('.group-home__scroll-box');
		var boxWidth = elem.width();
		var textWidth = $('.group-home__scroll-text', elem).width();
		if (textWidth > boxWidth) {
			var animSpeed = textWidth * 3.5;  // lower mulitiplier = faster
			elem.animate({
				scrollLeft: (textWidth - (boxWidth-50))  // included reduction in box width to makes sure edges are seen.
			}, animSpeed, function () {
				elem.animate({
					scrollLeft: 0
				}, animSpeed, function () {
					startAni();
				});
			});
		}
	}

	startAni();
}

function initGroupHomeSliders() {
	if ( typeof Swiper === 'undefined' ) return;

	$('.group-home__jaggy-slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 3000,
		infinite: true,
		cssEase: 'linear',
		responsive: [
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 3,
					centermode: true
				}
			}
		]
	})

	$('.slick-slide').each(function() {
		var slide = $(this);

		var slideIndex = $(this).data('slick-index');

		if (slideIndex < 0) {
			slideIndex = slideIndex * -1;
		}
	console.log(slideIndex);
		var numberOfSlidesDividingSix = slideIndex % 6;

		switch(numberOfSlidesDividingSix) {
			case 1:
				slide.addClass('item1')
				break;
			case 2:
				slide.addClass('item2')
				break;
			case 3:
				slide.addClass('item3')
				break;
			case 4:
				slide.addClass('item4')
				break;
				case 5:
				slide.addClass('item5')
				break;
			default:
				slide.addClass('item6')
		}

	})



	if ($('.group-hotels__slider').length > 0) {
		var swiper = new Swiper(".group-hotels__slider", {
			effect: "cards",
			grabCursor: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function(index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		})
	}


	$('.group-slider__scroll button').on('click', function() {
		var screenHeight = $(window).outerHeight();
		$('html, body').animate({
			scrollTop: screenHeight
		  },'slow');
	})
}

function initGroupLanding() {
	if ( typeof Swiper === 'undefined' ) return;

	var landingSwiper = new Swiper('.group-landing__grid-item-slider', {
		effect: "cards",
		grabCursor: true,
		navigation: {
			nextEl: ".swiper-navigation-next",
			prevEl: ".swiper-navigation-prev",
		},
	});
}

function addGroupCuratorHover() {
	$('body.group .curator').on('mouseenter', function() {
		$(this).find('.curator__titles').addClass('hover');
	});

	$('body.group .curator').on('mouseleave', function() {
		$(this).find('.curator__titles').removeClass('hover');
	});
}

function initTwitter () {
	var featured = $('.twitter__content-featured')
	var scroll = $('.twitter__content-scroll')

	setTimeout(function () {
		var h = featured.height() + 'px'
		scroll.css('height', h)
	},2000)

}

function initModalScroll() {

	$('#team__modal').slick({
		dots: false,
		arrows: true,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3
	});

}

// Deals with annoying video loading bug on initial load
document.addEventListener("DOMContentLoaded", function() {
	// Get the element by ID
	var whatsappAnimation = document.getElementById('whatsapp-animation');

	// Check if the element exists
	if (whatsappAnimation) {
		// Add an event listener for the 'canplay' event
		whatsappAnimation.addEventListener('canplay', function() {
			// Safely attempt to play the video
			try {
				whatsappAnimation.play();
			} catch (error) {
				console.error("Error playing video: ", error);
			}
		});
	} else {
		// Log if the element is not found
		console.log("Element 'whatsapp-animation' not found.");
	}
});

$(document).ready(function() {

	$('.ribbon__inner').slick({
	  speed: 9000,
	  autoplay: true,
	  autoplaySpeed: 0,
	  cssEase: 'linear',
	  slidesToShow: 5,
	  centerMode: true,
	  slidesToScroll: 1,
	  variableWidth: true,
	  arrows: false,
	});  

});

// Function to update the height based on screen width
function updateHeight() {
    // Check if screen width is less than 640px
    if (window.innerWidth < 640) {
        // Find the iframe within the .slider__video div
        var videoIframe = document.querySelector('.slider__video iframe');
        
        // If the iframe exists, proceed
        if (videoIframe) {
            // Get the height of the iframe
            var iframeHeight = videoIframe.offsetHeight;
            
            // Set the height of the .slider__inner div to the iframe's height
            var sliderInner = document.querySelector('.slider__inner');
            if (sliderInner) {
                sliderInner.style.height = iframeHeight + 'px';
            }
        }
    } else {
        // If screen width is more than 640px, remove the inline height
        var sliderInner = document.querySelector('.slider__inner');
        if (sliderInner) {
            sliderInner.style.removeProperty('height');
        }
    }
}

// Add an event listener for window resize
if (window.addEventListener) {
    window.addEventListener('resize', updateHeight);
} else if (window.attachEvent) { // For older versions of IE
    window.attachEvent('onresize', updateHeight);
}

// Trigger a resize event after a short delay to ensure elements are fully loaded
window.onload = function() {
    setTimeout(function() {
        if (document.createEvent) {
            var event = document.createEvent('Event');
            event.initEvent('resize', true, true);
            window.dispatchEvent(event);
        } else if (document.createEventObject) { // For older versions of IE
            var event = document.createEventObject();
            window.fireEvent('onresize', event);
        }
    }, 100); // 100ms delay
};
